import { AxiosError } from "axios";
import { useQuery } from "react-query";
import axiosClient from "../utils/axiosClient";

export type HighlightResponse = {
  count: number;
  rank: number;
  text: string;
  timestamps: {
    start: number;
    end: number;
  }[];
}[];

export const useHighlightJson = (url?: string) => {
  return useQuery<any, AxiosError<any>, HighlightResponse>(
    ["highlightJson", url],
    () =>
      axiosClient.get<HighlightResponse>(url || "").then(({ data }) => data),
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      enabled: !!url,
    }
  );
};
